import { render, staticRenderFns } from "./modifieddetail.vue?vue&type=template&id=7b918836&scoped=true&"
import script from "./modifieddetail.vue?vue&type=script&lang=js&"
export * from "./modifieddetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b918836",
  null
  
)

export default component.exports